import React from "react"
import { connect } from "react-redux"

import { updateLineItem } from "../../state/shop"
import { formatPrice } from "../../lib"

export const Cart = ({ checkout, updateItem, refProp }) => {
  const handleCheckout = () => {
    window.location = checkout.webUrl
  }

  return (
    <div className="cart" ref={refProp}>
      <div className="cart__items">
        {checkout.lineItems.map(item => {
          const linePrice = item.variant.price * item.quantity
          const formattedLinePrice = formatPrice(
            checkout.subtotalPriceV2.currencyCode,
            linePrice,
            0
          )

          const selectedOptions = item.variant.selectedOptions.map(
            o => `${o.name}: ${o.value}`
          )

          return (
            <div key={item.id} className="cart__item">
              <div>
                <h3>{item.title}</h3>
                <p>
                  {selectedOptions.map((option, idx) => {
                    if (idx !== selectedOptions.length - 1) {
                      return option + ", "
                    } else {
                      return option
                    }
                  })}
                </p>
              </div>
              <div>
                <button onClick={() => updateItem(item.id, item.quantity - 1)}>
                  -
                </button>
                <span>{item.quantity}</span>
                <button onClick={() => updateItem(item.id, item.quantity + 1)}>
                  +
                </button>
              </div>
              <div>{formattedLinePrice}</div>
            </div>
          )
        })}
      </div>
      <div className="cart__subtotal">
        <div></div>
        <div>Total</div>
        <div>
          {formatPrice(
            checkout.subtotalPriceV2.currencyCode,
            checkout.subtotalPriceV2.amount,
            0
          )}
        </div>
      </div>
      <div className="cart__checkout">
        <button
          onClick={handleCheckout}
          disabled={checkout.totalPrice === "0.00"}
        >
          Check Out
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  checkout: state.shop.checkout,
  shop: state.shop,
})

const mapDispatchToProps = dispatch => ({
  updateItem: (id, qty) => dispatch(updateLineItem(id, qty)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Cart)